var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlugOutline = function SvgPlugOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "plug-outline_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.5 0h24v24H.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#plug-outline_svg__a)",
    fill: "#232B3A"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 11.061c0-1.03.752-2.087 2.01-2.087h3.871c.17 0 .323-.112.55-.553.625-1.22 1.897-3.36 3.993-3.36H17V18.91h-5.576c-2.054 0-3.328-1.616-3.974-2.807-.224-.413-.265-.707-.546-.707H3.01c-1.285 0-2.01-1.308-2.01-2.338V11.06Zm7.47 1.996s.983 3.684 3.441 3.684h3.053V7.26H11.91c-2.458 0-3.44 3.802-3.44 3.802H3.01v1.996h5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 8h5a1 1 0 1 1 0 2h-5V8ZM16 19.974a1 1 0 0 1-1-1V5.152a1 1 0 1 1 2 0v13.822a1 1 0 0 1-1 1ZM17 14h5a1 1 0 1 1 0 2h-5v-2Z"
  }))));
};
export default SvgPlugOutline;